import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button,Form,Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { DocumentService } from "../../Common/Services/DocumentService";
import paginationFactory from 'react-bootstrap-table2-paginator';
import  DocumentSlideout  from "./DocumentSlideout";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { TransactionService } from "../../Common/Services/TransactionService";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import {
  faPlus,
  faMinus,
  faPaperclip
} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
const { SearchBar } = Search;

import createDOMPurify from "dompurify";
 
import moment from "moment";

  
 class Documents extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
          isSaveSpinner: false,
          showSlideout:false,
          htmlItem: [],
          htmlErrorItem: [],
          htmlWarningItem: [],
          searcResult: [],
          orderid:0,
          selectedcolumn: "All",
          selectOptions: [{
            id: 'All', name: 'All'
          },
          { id: 'ID', name: 'ID' },
          { id: 'Category', name: 'Category' },
          { id: 'Description', name: 'Description' },
          { id: 'File Type', name: 'File Type' },
          { id: 'Uploaded', name: 'Uploaded' },
          ],
        isId : true,
        isCategory : true,
        isDescription : true,
        isFiletype : true,
        isUploaded : true
        };
        
     
      }

      handleSelectedItem1 = (control: any, id: any) => {
        let searcResult1 = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.searcResult))
        );
    
        let isId = id == "ID" ? true : false;
        let isCategory = id == "Category" ? true : false;
        let isDescription = id == "Description" ? true : false;
        let isFiletype = id == "File Type" ? true : false;
        let isUploaded = id == "Uploaded" ? true : false;

    
        if (id == "All") {
          isId = true;
          isCategory = true;
          isDescription = true;
          isFiletype = true;
          isUploaded = true;
        }
    
    
        this.setState({
          searcResult: [], selectedcolumn: id, isId, isCategory,
          isDescription, isFiletype,isUploaded
        },
          () => {
            this.setState({ searcResult: searcResult1 });
          }
    
        );
    
      };
    
      componentDidMount() {
        let requestlist = { ...this.state.requestlist };
        this.getDocuments(requestlist);
      }

       componentDidUpdate(prevProps) {
        if (prevProps.locationId != this.props.locationId && !this.state.showSlideout) {
        let requestlist = { ...this.state.requestlist };
        this.getDocuments(requestlist);
        }
      }


 
      getDocuments = (requestlist: any) => {
 

        DocumentService.GetAllDocument(requestlist)
    .then(async (result: any[] | null) => {
        
      if (result != null) {
        
        this.setState({ searcResult: [] }, () => {
           this.setState({ searcResult: result });
        });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      reject();
    });
  };

  showslideout = () => {
    this.setState({ showSlideout: true });
  };

  closeSlideOut = () => {
    this.setState({ showSlideout: false ,Id:0,docNumber:"",stringId:""});
    this.getDocuments({});
  };

  rowEvents = {

    onClick: (e: any, row: any, rowIndex: any) => {
      // if (row.receivedStatus === 'Completed' || row.receivedStatus === 'Initial') {
        this.setState({
          showSlideout: true, 
          Id: row.id,
          docNumber: row.docNumber,
          stringId:row.stringId
        });
     // }
    },
  };

   downloadTranactionFile = (file: any) => {
          TransactionService.DownloadTransactionFile(file)
            .then(async (result: any | null) => {
            this.setState({ isSaveSpinner: false });
              resolve();
            })
            .catch((error) => {
              reject();
              this.setState({ isSaveSpinner: false });
            });
        };
    

  GetUploadFileList = (attachmentid: any,detailid:any) => {
    this.setState({ isSaveSpinner: true });
        let requestlist: any = {};
    
        requestlist.transactionID = detailid;
        requestlist.transactionType = "documentDetails";
    
        TransactionService.GetUploadFileWithFileCodeTransaction(requestlist)
          .then(async (result: any | null) => {
            if (result.length > 0) {
              const matchedObj = result.find(
                (obj: any) => obj.id == attachmentid
              );

          if (matchedObj) {
            this.downloadTranactionFile(matchedObj);
          } 
            
            } else {
            toast.error(`No File uploaded`);
            this.setState({ isSaveSpinner: false });
            }
            resolve();
          })
          .catch((error) => {
            reject();
            this.setState({ isSaveSpinner: false });
          });
      };

   handleAttachmentClick = (attachmentid: any,detailid:any) => {
    this.GetUploadFileList(attachmentid,detailid);
  };

    render() { 
      const { permissions } = this.props; 
      const hasAddDocumentPermission = permissions && permissions['Add Document'] ? true : false;
      const customTotal = (from, to, size) => (
        <span className="text-muted">
          Showing {from} to {to} of {size} entries
        </span>
      );
      const options = {
  
        showTotal: true,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        paginationTotalRenderer: customTotal,
        disablePageTitle: true,
        sizePerPageList: [{
          text: '10', value: 10
        },
        {
          text: '25', value: 25
        },
        {
          text: '50', value: 50
        },
  
        {
          text: 'All', value: this.state.searcResult.length
        }] // A numeric array is also available. the purpose of above example is custom the text
      };
  
      const columns = [
        {
          dataField: 'docNumber',
          text: 'DOC ID.',
          sort: true,
          hidden:true,
         
        },
        {
          dataField: 'documentType',
          text: 'Category',
          sort: true,
          searchable: this.state.isCategory,
        },
        {
          dataField: 'stringId',
          text: 'ID',
          sort: true,
           searchable: this.state.isId,
        },
        {
          dataField: 'description',
          text: 'Description',
          sort: true,
           searchable: this.state.isDescription,
        },
        
          {
                  dataField: "uploadedDate",
                  text: "Uploaded",
                  sort: true,
                  searchable: this.state.isUploaded,
                  formatter: (cell: any, row: any, rowIndex: any) => {
                    return (
                      <EllipsisWithTooltip placement="bottom">
                         { row.date=="0001-01-01T00:00:00" || row.uploadedDate==undefined ? "" : moment(row.uploadedDate).format("MM/DD/YYYY")}
                      </EllipsisWithTooltip>
                    );
                  },
                },
      {
          dataField: 'fileType',
          text: 'File Type',
          searchable: this.state.isFiletype,
          sort: true,
        },
         {
                        dataField: "isFile",
                        text: "Download",
                        headerClasses: "coa",
                        classes:'text-center',
                        headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
                        formatter: (cell: any, row: any, rowIndex: any) => {
                          return (
                            row.attachmentid && row.attachmentid !== null ? (
                              <div className="cursor-pointer" 
                               onClick={(e) => {
                                e.preventDefault(); 
                                e.stopPropagation();
                                this.handleAttachmentClick(row.attachmentid, row.detailid);
                              }}
                              >
                                
                                 <FontAwesomeIcon icon={faPaperclip} />
                              </div>
                            ):(
                              <></>
                            )
                          );
                        },
                      }
       
      ];

        return (
            <>
<React.Fragment>
  
        
          <Container fluid className="body-sec">
           

              <div className="page-heading  d-flex  ">

              Documents
              {hasAddDocumentPermission &&
<div className="action-group d-flex flex-row ml-auto">
  { <Button onClick={this.showslideout}>Add Document</Button> }
</div>}
</div>

              
              {/* <BootstrapTable
        keyField="id"
        data={this.state.searcResult}
        columns={columns}
       rowEvents={this.rowEvents}
       pagination={ paginationFactory() }
      /> */}

<ToolkitProvider
                    keyField="id"
                    data={this.state.searcResult}
                    columns={columns}

                    search
                  >
                    {
                      props => (
                        <div>

<section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>

                            <div 
                            //className="input-group w-auto"
                            className="col-12 col-md-2"
                            >
                                <SingleDropdownListWithoutSearch
                                  
                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}

                                />
                            </div>

                          </section>
                          <section className="pb-3">
                            <div className="table-responsive1 divbottom"  >
                              <div className="ml-auto transactions-list payroll-tbl">
                          <BootstrapTable
                            {...props.baseProps}
                            rowEvents={this.rowEvents}
                            pagination={paginationFactory(options)}
                            
                          />
                       </div>
                            </div>
                          </section>
                        </div>
                      )
                    }
                  </ToolkitProvider>

  {(this.state.isSaveSpinner) && (
                  <div className="loader-spinner d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="success" />
                  </div>
                )}

{this.state.showSlideout && (
 <DocumentSlideout  
 closeSlideOut={this.closeSlideOut} 
 Id={this.state.Id} 
 docNumber={this.state.docNumber}
 stringId={this.state.stringId}
 />
)}
   </Container>
       
      
      </React.Fragment>
            </>
        );
    }

}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId  
});

export default connect(mapStateToProps)(Documents);
